// extracted by mini-css-extract-plugin
module.exports = {"countDownWrap":"LiveCountdown_countDownWrap__3MM3w","countdownValues":"LiveCountdown_countdownValues__1z9XS"};